module.exports = __webpack_public_path__ + "static/blog-02-f48b78472e868dedf2b30352f0f666b8.jpg";